import { Global } from '../../Global';
import { encodeRFC3986URIComponent } from '../miscFunctions';

export const createHeaders = (
  contentType = 'application/json',
  kundmarke?: string
): Headers => {
  const headers = new Headers();
  headers.set('Source', 'fsok');
  headers.set('Pragma', 'no-cache'); // IE11
  Global.backend && headers.set('backend', Global.backend);
  kundmarke &&
    headers.set('X-Ipm-Kundmarke', encodeRFC3986URIComponent(kundmarke));
  headers.set('XP-BEL-Origin', 'fastighetsok');

  if (contentType !== 'multipart/form-data') {
    headers.set('Content-Type', contentType);
  }

  if (process.env.NODE_ENV === 'development') {
    const auth = btoa(`${Global.username}:${Global.password}`);
    headers.set('Authorization', `Basic ${auth}`);
  }

  return headers;
};
